<template>
  <div>
    <OverlayLoader v-if="exportLoading" />
    <CRow>
      <CCol> </CCol>
    </CRow>
    <br />
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader> List of Polls </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <date-range-picker
                  v-model="dateRange"
                  :ranges="false"
                  :single-date-picker="'range'"
                  :locale-data="{ firstDay: 1, format: 'yyyy/mm/dd' }"
                  @update="updateDate"
                  class="filter-bar-item custom-datepicker"
                />
              </CCol>
              <CCol>
                <div v-if="checkAction('poll_add')">
                  <router-link :to="'/polls/create-polls'">
                    <CButton
                      class="float-right"
                      variant="outline"
                      color="success"
                      shape="pill"
                    >
                      Create New Poll
                    </CButton>
                  </router-link>
                </div>
                <div>
                  <CButton
                    class="float-right mr-2"
                    variant="outline"
                    color="warning"
                    shape="pill"
                    @click="exportToCsv"
                  >
                    Export To CSV
                  </CButton>
                </div>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <CCol>
                <CDataTable
                  v-bind:loading="loading"
                  :items="polls"
                  small
                  :columnFilter="{ external: true }"
                  :sorter="{ external: true, resetable: false }"
                  pagination
                  :fields="fields"
                  :key="polls.id"
                  :column-filter-value="filters"
                  @update:column-filter-value="onFilterChange"
                  @update:sorter-value="onSorterChange"
                >
                  <template #unique_id="{ item }">
                    <td>
                      {{ item.article_unique_id }}
                    </td>
                  </template>
                  <template #name="{ item }">
                    <td style="max-width: 500px">
                      {{ item.name }}
                    </td>
                  </template>
                  <template #published_date="{ item }">
                    <td>
                      {{ item.published_date | dates }}
                    </td>
                  </template>
                  <template v-if="loading" #no-items-view>
                    <div style="height: 300px"></div>
                  </template>
                  <template #is_sponsored="{ item }">
                    <td>
                      <CBadge :color="getBadge(item.is_sponsored)">{{
                        item.is_sponsored
                      }}</CBadge>
                    </td>
                  </template>
                  <template #total_responses="{ item }">
                    <td>
                      {{ item.total_responses | numbers }}
                    </td>
                  </template>
                  <template #show_details="{ item }">
                    <td>
                      <CButtonToolbar>
                        <EditPollModal
                          :key="item.id"
                          v-if="checkAction('poll_edit')"
                          :poll="item"
                          :section="true"
                        />
                        <div v-show="checkAction('poll_show')">
                          <CButton
                            @click="redirectTo(item.id)"
                            color="primary"
                            variant="outline"
                            v-c-tooltip="'Show Poll'"
                          >
                            <CIcon name="cil-envelope-open"></CIcon>
                          </CButton>
                        </div>
                        <CButton
                          v-if="checkAction('poll_archive')"
                          variant="outline"
                          v-bind:color="getColor(item.status)"
                          v-c-tooltip="'Toggle Archive Poll'"
                          @click="deletePoll(item)"
                        >
                          <CIcon v-bind:name="getIcon(item.status)"></CIcon>
                        </CButton>
                      </CButtonToolbar>
                    </td>
                  </template>
                </CDataTable>
                <CPagination
                  @update:activePage="goToPage"
                  :pages="pagination.last_page"
                  :activePage.sync="pagination.current_page"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import EditPollModal from './EditPollModal';
import OverlayLoader from '../views/OverlayLoader';
import { mapGetters, mapActions } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'ListPolls',
  components: { DateRangePicker, EditPollModal, OverlayLoader },
  data() {
    let startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);
    let endDate = new Date();
    return {
      fields: [
        { key: 'id', label: 'Poll ID', filter: true },
        { key: 'unique_id', label: 'Unique ID', filter: true },
        { key: 'name', label: 'Poll Name', filter: true },
        { key: 'published_date', label: 'Start Date', filter: false },
        { key: 'close_at', label: 'End Date', filter: false },
        { key: 'option_type', label: 'Type', filter: false },
        { key: 'status', label: 'Status', filter: false },
        { key: 'is_sponsored', label: 'Sponsored', filter: false },
        { key: 'total_responses', label: 'Total Responses', filter: false },
        {
          key: 'reactions',
          label: 'Total Reactions',
          filter: false,
          sorter: false,
        },
        {
          key: 'comments',
          label: 'Total Comments',
          filter: false,
          sorter: false,
        },
        { key: 'shares', label: 'Total Shares', filter: false, sorter: false },
        { key: 'show_details', sorter: false, label: 'Actions', filter: false },
      ],
      dateRange: { startDate, endDate },
      searchKeyword: '',
      filters: { id: null, unique_id: null, name: null },
      sorters: { asc: null, column: null },
      debounceTimer: null,
      exportLoading: false,
    };
  },
  filters: {
    dates(val) {
      let base = new Date(val);
      let dd = base.getDate();
      if (dd < 10) dd = '0' + dd;
      let mm = base.getMonth() + 1;
      if (mm < 10) mm = '0' + mm;
      let yy = base.getFullYear();
      return yy + '-' + mm + '-' + dd;
    },
    sponsored(val) {
      return val === 1 ? 'Yes' : 'No';
    },
    numbers(val) {
      return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },
  computed: {
    ...mapGetters({
      loading: 'getVideoLoading',
      polls: 'getPolls',
      pagination: 'getPollPagination',
    }),
    polls() {
      return this.$store.getters.getAllPoll;
    },
    loading() {
      return this.$store.getters.getPollLoading;
    },
  },
  created() {
    this.getPolls({
      currentPage: 1,
      startDate: this.formatDate(this.dateRange.startDate),
      endDate: this.formatDate(this.dateRange.endDate),
    });
  },
  methods: {
    ...mapActions({
      getPolls: 'getPolls',
    }),
    updateDate(dateRange) {
      this.dateRange = dateRange;

      let id = null;
      let unique_id = null;
      let name = null;
      let sortBy = null;
      let asc = null;

      if (this.filters.id) {
        id = this.filters.id;
      }
      if (this.filters.name) {
        name = this.filters.name;
      }
      if (this.filters.unique_id) {
        unique_id = this.filters.unique_id;
      }
      if (this.sorters.column != null && this.sorters.asc != null) {
        sortBy = this.sorters.column;
        asc = this.sorters.asc;
      }

      this.getPolls({
        pollId: id,
        pollUniqueId: unique_id,
        pollName: name,
        sortBy: sortBy,
        asc: asc,
        startDate: this.formatDate(this.dateRange.startDate),
        endDate: this.formatDate(this.dateRange.endDate),
      });
    },
    formatDate(date) {
      console.log(date);
      return date.toISOString().split('T')[0];
    },
    async onFilterChange(updatedFilters) {
      clearTimeout(this.debounceTimer);

      this.filters = updatedFilters;
      this.debounceTimer = setTimeout(() => {
        let id = null;
        let unique_id = null;
        let name = null;
        let sortBy = null;
        let asc = null;
        if (this.filters.id) {
          id = this.filters.id;
        }
        if (this.filters.name) {
          name = this.filters.name;
        }

        if (this.filters.unique_id) {
          unique_id = this.filters.unique_id;
        }

        if (this.sorters.column != null && this.sorters.asc != null) {
          sortBy = this.sorters.column;
          asc = this.sorters.asc;
        }

        this.getPolls({
          pollId: id,
          pollUniqueId: unique_id,
          pollName: name,
          sortBy: sortBy,
          asc: asc,
          startDate: this.formatDate(this.dateRange.startDate),
          endDate: this.formatDate(this.dateRange.endDate),
        });
      }, 1000);
    },
    async onSorterChange(updatedSorter) {
      this.sorters = updatedSorter;
      let sortBy = this.sorters.column;
      let asc = this.sorters.asc;
      let id = null;
      let unique_id = null;
      let name = null;
      if (this.filters.id) {
        id = this.filters.id;
      }
      if (this.filters.name) {
        name = this.filters.name;
      }

      if (this.filters.unique_id) {
        unique_id = this.filters.unique_id;
      }

      this.getPolls({
        pollId: id,
        pollUniqueId: unique_id,
        pollName: name,
        sortBy: sortBy,
        asc: asc,
        startDate: this.formatDate(this.dateRange.startDate),
        endDate: this.formatDate(this.dateRange.endDate),
      });
    },
    redirectTo(id) {
      this.$router.push('/polls/show-poll/' + id);
    },
    goToPage(currentPage) {
      let id = null;
      let unique_id = null;
      let name = null;
      let sortBy = null;
      let asc = null;
      if (this.filters.id) {
        id = this.filters.id;
      }
      if (this.filters.name) {
        name = this.filters.name;
      }

      if (this.filters.unique_id) {
        unique_id = this.filters.unique_id;
      }

      if (this.sorters.column != null && this.sorters.asc != null) {
        sortBy = this.sorters.column;
        asc = this.sorters.asc;
      }

      this.getPolls({
        pollId: id,
        pollUniqueId: unique_id,
        pollName: name,
        sortBy: sortBy,
        asc: asc,
        startDate: this.formatDate(this.dateRange.startDate),
        endDate: this.formatDate(this.dateRange.endDate),
        currentPage: currentPage,
      });
    },
    async deletePoll(poll) {
      let msg = '';
      if (poll.status === 'archived') {
        msg = 'This will un-archive the poll. Are you sure?';
      } else {
        msg = 'This will archive the poll. Are you sure?';
      }
      if (confirm(msg)) {
        let data = JSON.parse(JSON.stringify(poll));
        if (data.status === 'archived') {
          data.status = 'active';
        } else {
          data.status = 'archived';
        }
        data.is_sponsored = data.is_sponsored === 'Yes' ? 1 : 0;
        data.random = data.random === 'Yes' ? 1 : 0;
        await this.$store.dispatch('archivePoll', data);
      }
    },
    getColor(status) {
      return status === 'archived' ? 'success' : 'danger';
    },
    getIcon(status) {
      return status == 'archived' ? 'cil-action-redo' : 'cil-book';
    },
    getBadge(status) {
      return status === 'Yes' ? 'success' : 'danger';
    },
    async getAllPollsForExport() {
      const axios = require('axios');
      const headers = require('@/helpers/headers');

      let allPolls = [];
      let currentPage = 1;
      let totalPages = 1;

      let id = null;
      let unique_id = null;
      let name = null;
      let sortBy = null;
      let asc = null;

      if (this.filters.id) {
        id = this.filters.id;
      }
      if (this.filters.name) {
        name = this.filters.name;
      }
      if (this.filters.unique_id) {
        unique_id = this.filters.unique_id;
      }
      if (this.sorters.column != null && this.sorters.asc != null) {
        sortBy = this.sorters.column;
        asc = this.sorters.asc;
      }

      let dateFrom = this.formatDate(this.dateRange.startDate);
      let dateTo = this.formatDate(this.dateRange.endDate);

      try {
        do {
          let r = Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
          let url = process.env.VUE_APP_GET_POLLS;
          url = url + '?page=' + currentPage;

          if (dateFrom != null && dateFrom !== 'undefined') {
            url = url + '&dateFrom=' + dateFrom;
          }

          if (dateTo != null && dateTo !== 'undefined') {
            url = url + '&dateTo=' + dateTo;
          }

          if (id != null) {
            url = url + '&pollId=' + id;
          }

          if (name != null) {
            url = url + '&pollName=' + name;
          }

          if (unique_id != null) {
            url = url + '&pollUniqueId=' + unique_id;
          }

          if (sortBy != null && asc != null) {
            url = url + '&sortBy=' + sortBy + '&sortDirection=' + asc;
          }

          const response = await axios.get(
            url + '&r=' + r,
            headers.createHeaders(
              this.$store.state.user.token,
              process.env.VUE_APP_TOKEN_VALUE
            )
          );

          const polls = response.data.data.map((item) => ({
            ...item,
            is_sponsored: item.is_sponsored === 1 ? 'Yes' : 'No',
            random: item.random === 1 ? 'Yes' : 'No',
          }));

          allPolls = allPolls.concat(polls);

          if (currentPage === 1 && response.data.pagination) {
            totalPages = response.data.pagination.last_page || 1;
          }

          currentPage++;
        } while (currentPage <= totalPages);

        return allPolls;
      } catch (err) {
        console.error('Error fetching all polls:', err);
        this.$notify({
          group: 'error',
          title: 'Error',
          type: 'error',
          text: 'Failed to fetch all polls for export',
          duration: 5000,
          position: 'bottom right',
        });
        return [];
      }
    },
    async exportToCsv() {
      this.exportLoading = true;

      try {
        let BOM = '\uFEFF';
        let dateFrom = this.formatDate(this.dateRange.startDate);
        let dateTo = this.formatDate(this.dateRange.endDate);
        let csv = '';

        csv += 'Poll Export Report\n';
        csv += `Date Range: ${dateFrom} to ${dateTo}\n\n`;
        csv +=
          'Poll ID,Unique ID,Poll Name,Poll Title,Start Date,End Date,Type,Status,Sponsored,Total Responses,Total Reactions,Total Comments,Total Shares\n';

        // Fetch all polls across all pages
        const allPolls = await this.getAllPollsForExport();

        if (allPolls.length === 0) {
          this.$notify({
            group: 'error',
            title: 'No Data',
            type: 'warning',
            text: 'No polls found in the selected date range',
            duration: 3000,
            position: 'bottom right',
          });
          return;
        }

        allPolls.forEach((poll) => {
          const formatDateForCsv = (dateStr) => {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}/${month}/${day}`;
          };

          const publishedDate = formatDateForCsv(poll.published_date);
          const closeAt = formatDateForCsv(poll.close_at);

          csv += `"${poll.id}","${poll.article_unique_id || ''}","${poll.name}","${poll.text}","=""${publishedDate}""","=""${closeAt}""","${poll.option_type}","${poll.status}","${poll.is_sponsored}","${poll.total_responses}","${poll.reactions}","${poll.comments}","${poll.shares}"\n`;
        });

        console.log(`Exported ${allPolls.length} polls to CSV`);

        let reportName = `Polls_Export_${dateFrom}_to_${dateTo}.csv`;
        let hiddenElement = document.createElement('a');
        hiddenElement.href =
          'data:text/csv;charset=utf-8,' + encodeURIComponent(BOM + csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = reportName;
        hiddenElement.click();

        // Show success notification
        this.$notify({
          group: 'success',
          title: 'Export Complete',
          type: 'success',
          text: `Successfully exported ${allPolls.length} polls to CSV`,
          duration: 3000,
          position: 'bottom right',
        });
      } catch (error) {
        console.error('Error during CSV export:', error);
        this.$notify({
          group: 'error',
          title: 'Export Failed',
          type: 'error',
          text: 'An error occurred while exporting polls to CSV',
          duration: 5000,
          position: 'bottom right',
        });
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
